(() => {
  if (window.DripnordProductFocus) return;
  const pointerAttribute = 'data-dn-pointer-focus';
  const controlSelector = 'a[href], button, summary, select, input, [tabindex], [role="button"], [role="tab"]';
  const pointerInputTypes = new Set(['button', 'submit', 'reset', 'checkbox', 'radio']);
  let modality = 'keyboard';
  let markedControl = null;

  function isRefinedPage() {
    return Boolean(document.querySelector('.dn-product-refined'));
  }

  function clearPointerFocus() {
    markedControl?.removeAttribute(pointerAttribute);
    markedControl = null;
  }

  function isPointerControl(element) {
    if (!(element instanceof HTMLElement) || element.isContentEditable || element.matches('textarea')) return false;
    if (element.matches('input') && !pointerInputTypes.has(element.type)) return false;
    return element.matches(controlSelector);
  }

  function applyFocusIntent(element) {
    clearPointerFocus();
    if (modality !== 'pointer' || !isRefinedPage() || !isPointerControl(element)) return;
    element.setAttribute(pointerAttribute, '');
    markedControl = element;
  }

  document.addEventListener('pointerdown', () => {
    if (!isRefinedPage()) return;
    modality = 'pointer';
    applyFocusIntent(document.activeElement);
  }, { capture: true, passive: true });

  document.addEventListener('keydown', (event) => {
    if (!isRefinedPage() || event.metaKey || event.ctrlKey || event.altKey || ['Shift', 'Control', 'Alt', 'Meta'].includes(event.key)) return;
    modality = 'keyboard';
    clearPointerFocus();
  }, true);

  document.addEventListener('focusin', (event) => applyFocusIntent(event.target), true);
  document.addEventListener('focusout', (event) => {
    if (event.target === markedControl) clearPointerFocus();
  }, true);

  window.DripnordProductFocus = {
    focus(element, options = {}) {
      if (!element?.isConnected || typeof element.focus !== 'function') return;
      applyFocusIntent(element);
      element.focus({ preventScroll: true, ...options });
    }
  };
})();
